import type { IStyleFunctionOrObject } from '@fluentui/react';
import type { IActionCardStyle, IActionCardStyleProps } from '@m365-admin/card';

export function getActionCardStyles(
  props: IActionCardStyleProps,
): IStyleFunctionOrObject<IActionCardStyleProps, IActionCardStyle> {
  const { theme } = props;

  const styles: Partial<IActionCardStyle> = {
    root: { minHeight: 78 }, // account for 2px borders and this brings us to 80px tall per spec
    primaryText: {
      fontSize: theme.fonts.medium.fontSize,
    },
    contentWrapper: {
      paddingTop: 8,
      paddingBottom: 8,
    },
    subComponentStyles: {
      mainIcon: {
        root: {
          gridRowEnd: 'span 2',
        },
      },
      iconButton: {},
    },
  };

  return styles;
}
